(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("liferay-widgets-react-web/js/liferay-widgets-react-web"), require("fliwas-structure-portlet/js/fliwas-structure-portlet"), require("keymirror"), require("lwr-client"), require("react"), require("user-state-history-portlet/js/user-state-history-portlet"), require("base-portlet/js/base-portlet"), require("react-bootstrap"), require("prop-types"), require("datefns"));
	else if(typeof define === 'function' && define.amd)
		define(["liferay-widgets-react-web/js/liferay-widgets-react-web", "fliwas-structure-portlet/js/fliwas-structure-portlet", "keymirror", "lwr-client", "react", "user-state-history-portlet/js/user-state-history-portlet", "base-portlet/js/base-portlet", "react-bootstrap", "prop-types", "datefns"], factory);
	else if(typeof exports === 'object')
		exports["state-portlet"] = factory(require("liferay-widgets-react-web/js/liferay-widgets-react-web"), require("fliwas-structure-portlet/js/fliwas-structure-portlet"), require("keymirror"), require("lwr-client"), require("react"), require("user-state-history-portlet/js/user-state-history-portlet"), require("base-portlet/js/base-portlet"), require("react-bootstrap"), require("prop-types"), require("datefns"));
	else
		root["state-portlet"] = factory(root["liferay-widgets-react-web/js/liferay-widgets-react-web"], root["fliwas-structure-portlet/js/fliwas-structure-portlet"], root["keymirror"], root["lwr-client"], root["react"], root["user-state-history-portlet/js/user-state-history-portlet"], root["base-portlet/js/base-portlet"], root["react-bootstrap"], root["prop-types"], root["datefns"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_10__, __WEBPACK_EXTERNAL_MODULE_12__, __WEBPACK_EXTERNAL_MODULE_13__, __WEBPACK_EXTERNAL_MODULE_14__, __WEBPACK_EXTERNAL_MODULE_15__, __WEBPACK_EXTERNAL_MODULE_17__, __WEBPACK_EXTERNAL_MODULE_21__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(1);


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	//Includes
	
	exports.__esModule = true;
	exports.FliwasListItemStatus = exports.FliwasStatusIcon = exports.StateDetailsList = exports.StateValueLabel = exports.StateValueList = exports.StatusLine = exports.DetailsBoxStatus = exports.StateValueListItem = exports.StateValueEditForm = exports.StateSelect = exports.StateEditForm = exports.MiniWidgetStatusLine = exports.StateValueActions = exports.StateActions = exports.DetailsRenderer_StateValue = exports.ChangeRecordRenderer_StateValue = exports.StateValue = exports.State = exports.StateValueWebApi = exports.StateWebApi = exports.FormIds = exports.ClassNames = undefined;
	
	var _StoreFactory = __webpack_require__(2);
	
	Object.keys(_StoreFactory).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _StoreFactory[key];
	        }
	    });
	});
	
	var _MiniWidgetStatusLine = __webpack_require__(11);
	
	Object.defineProperty(exports, 'MiniWidgetStatusLine', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_MiniWidgetStatusLine).default;
	    }
	});
	
	var _StateEditForm = __webpack_require__(18);
	
	Object.defineProperty(exports, 'StateEditForm', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_StateEditForm).default;
	    }
	});
	
	var _StateSelect = __webpack_require__(19);
	
	Object.defineProperty(exports, 'StateSelect', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_StateSelect).default;
	    }
	});
	
	var _StateValueEditForm = __webpack_require__(20);
	
	Object.defineProperty(exports, 'StateValueEditForm', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_StateValueEditForm).default;
	    }
	});
	
	var _StateValueListItem = __webpack_require__(22);
	
	Object.defineProperty(exports, 'StateValueListItem', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_StateValueListItem).default;
	    }
	});
	
	var _DetailsBoxStatus = __webpack_require__(23);
	
	Object.defineProperty(exports, 'DetailsBoxStatus', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_DetailsBoxStatus).default;
	    }
	});
	Object.defineProperty(exports, 'StatusLine', {
	    enumerable: true,
	    get: function get() {
	        return _DetailsBoxStatus.StatusLine;
	    }
	});
	
	var _StateValueList = __webpack_require__(26);
	
	Object.defineProperty(exports, 'StateValueList', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_StateValueList).default;
	    }
	});
	
	var _StateValueLabel = __webpack_require__(16);
	
	Object.defineProperty(exports, 'StateValueLabel', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_StateValueLabel).default;
	    }
	});
	
	var _StateDetailsList = __webpack_require__(25);
	
	Object.defineProperty(exports, 'StateDetailsList', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_StateDetailsList).default;
	    }
	});
	
	var _FliwasStatusIcon = __webpack_require__(27);
	
	Object.defineProperty(exports, 'FliwasStatusIcon', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_FliwasStatusIcon).default;
	    }
	});
	
	var _FliwasListItemStatus = __webpack_require__(28);
	
	Object.defineProperty(exports, 'FliwasListItemStatus', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_FliwasListItemStatus).default;
	    }
	});
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _basePortlet = __webpack_require__(14);
	
	var _Constants = __webpack_require__(6);
	
	var _StateValueChangeRecordRenderer = __webpack_require__(29);
	
	var _StateValueChangeRecordRenderer2 = _interopRequireDefault(_StateValueChangeRecordRenderer);
	
	var _StateValueDetailsListRenderer = __webpack_require__(30);
	
	var _StateValueDetailsListRenderer2 = _interopRequireDefault(_StateValueDetailsListRenderer);
	
	var _StateWebApi = __webpack_require__(31);
	
	var _StateWebApi2 = _interopRequireDefault(_StateWebApi);
	
	var _StateValueWebApi = __webpack_require__(9);
	
	var _StateValueWebApi2 = _interopRequireDefault(_StateValueWebApi);
	
	var _StateActions = __webpack_require__(32);
	
	var _StateActions2 = _interopRequireDefault(_StateActions);
	
	var _StateValueActions = __webpack_require__(24);
	
	var _StateValueActions2 = _interopRequireDefault(_StateValueActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Actions
	
	// WebApi
	exports.ClassNames = _Constants.ClassNames;
	exports.FormIds = _Constants.FormIds;
	//Store-Factory
	
	exports.StateWebApi = _StateWebApi2.default;
	exports.StateValueWebApi = _StateValueWebApi2.default;
	
	
	_liferayWidgetsReactWeb.AppContext.registerBundle({
	    webApis: {
	        StateWebApi: _StateWebApi2.default,
	        StateValueWebApi: _StateValueWebApi2.default
	    }
	});
	
	/*
	 * Export bundled Modules i.e. require(ChangeRecordRenderer/StateValue, renderer=> {...}).
	 * See package.json and build.json
	 */
	var State = exports.State = undefined;
	var StateValue = exports.StateValue = undefined;
	var ChangeRecordRenderer_StateValue = exports.ChangeRecordRenderer_StateValue = _StateValueChangeRecordRenderer2.default; //ChangeRecordRenderer/StateValue
	var DetailsRenderer_StateValue = exports.DetailsRenderer_StateValue = _StateValueDetailsListRenderer2.default; //DetailsRenderer/StateValue
	
	exports.StateActions = _StateActions2.default;
	exports.StateValueActions = _StateValueActions2.default;
	
	
	console.warn('TODO cleanup StateActions.attachedList');
	_StateActions2.default.load(); //early states
	_StateActions2.default.attachedList('GroupStates', _liferayWidgetsReactWeb.AppContext.getScopeGroupId(), _basePortlet.ClassNames.Group, {}); //early states
	
	//const StateValueStore = getStateValueStore(AppContext);
	var StateStore = (0, _StoreFactory.getStateStore)(_liferayWidgetsReactWeb.AppContext);
	if (!StateStore.getStates()) console.warn('GroupStates not initialized');

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getStateStore = getStateStore;
	exports.getStateValueStore = getStateValueStore;
	
	var _StateStore = __webpack_require__(3);
	
	var _StateStore2 = _interopRequireDefault(_StateStore);
	
	var _StateValueStore = __webpack_require__(8);
	
	var _StateValueStore2 = _interopRequireDefault(_StateValueStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 28.01.2016
	 * Copyright: xdot GmbH 2015
	 */
	
	var stateStoreInstance = void 0;
	
	function getStateStore(AppContext) {
	    return stateStoreInstance || (stateStoreInstance = AppContext.createStore(_StateStore2.default));
	}
	
	var stateValueStoreInstance = void 0;
	
	function getStateValueStore(AppContext) {
	    return stateValueStoreInstance || (stateValueStoreInstance = AppContext.createStore(_StateValueStore2.default));
	}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _fliwasStructurePortlet = __webpack_require__(5);
	
	var _Constants = __webpack_require__(6);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * User: CBuehler on 23.09.2015
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var FliwasOrganizationStore = (0, _fliwasStructurePortlet.getFliwasOrganizationStore)(_liferayWidgetsReactWeb.AppContext);
	
	var statesByClassNamePropName = {};
	var statesByClassName = {};
	var cacheKey = null;
	
	var _buildCache = function _buildCache(list) {
	    cacheKey = list;
	    statesByClassNamePropName = {};
	    list.forEach(function (p) {
	        var propName = p.propName,
	            className = p.className;
	
	        var sByClassName = statesByClassName[className];
	        var sByClassNamePropName = statesByClassNamePropName[className + '___' + propName];
	        sByClassNamePropName = sByClassNamePropName && Array.isArray(sByClassNamePropName) ? sByClassNamePropName.concat(p) : [p];
	        sByClassName = sByClassName && Array.isArray(sByClassName) ? sByClassName.concat(p) : [p];
	        statesByClassNamePropName[className + '___' + propName] = sByClassNamePropName;
	        statesByClassName[className] = sByClassName;
	    });
	};
	
	console.warn('TODO cleanup StateStore.'); //todo Do we need a complex cache!? try load all and store by className!
	
	var StateStore = function (_ClassRemoteDataStore) {
	    _inherits(StateStore, _ClassRemoteDataStore);
	
	    function StateStore(Dispatcher) {
	        _classCallCheck(this, StateStore);
	
	        return _possibleConstructorReturn(this, _ClassRemoteDataStore.call(this, Dispatcher, _Constants.ClassNames.State));
	    }
	
	    StateStore.prototype.getGroupRemoteState = function getGroupRemoteState() {
	        return this.getRemoteState()['GroupStates'];
	    };
	
	    StateStore.prototype.getStates = function getStates() {
	        return this.getGroupRemoteState() || [];
	    };
	
	    StateStore.prototype.getStatesByClassName = function getStatesByClassName(className) {
	        this.buildCache();
	        return statesByClassName[className];
	    };
	
	    StateStore.prototype.getStatesByClassNamePropName = function getStatesByClassNamePropName(className, propName) {
	        if (propName === _Constants.OVERALL_STATE_PROP_NAME) {
	            className = '';
	        }
	        this.buildCache();
	        var allStates = statesByClassNamePropName[className + '___' + propName] || [];
	        return this.getStatesFromHirachy(allStates);
	    };
	
	    StateStore.prototype.getStatesFromHirachy = function getStatesFromHirachy(allStates) {
	        var currentOrg = _liferayWidgetsReactWeb.DataUtil.asItem(FliwasOrganizationStore.getRemoteData(_fliwasStructurePortlet.STORE_KEY_CURRENT_ORGANIZATION));
	
	        var states = allStates.filter(function (state) {
	            return state.groupId === currentOrg.groupId;
	        }); //Load from Current Org
	        if (states.length === 0) {
	            //No states for current Org => Load from FeferalState
	            states = allStates.filter(function (state) {
	                return state.groupId === currentOrg.federalStateGroupId;
	            });
	            if (states.length === 0) {
	                //No states for FederalState => Load from Global
	                states = allStates.filter(function (state) {
	                    return state.groupId === currentOrg.globalGroupId;
	                });
	            }
	        }
	        return states;
	    };
	
	    StateStore.prototype.buildCache = function buildCache() {
	        var groupState = this.getGroupRemoteState();
	        if (groupState && groupState.item) {
	            if (cacheKey != groupState.item) {
	                _buildCache(groupState.item);
	            }
	        }
	    };
	
	    StateStore.prototype.getStateByClassNamePropNameStateId = function getStateByClassNamePropNameStateId(className, propName, stateId) {
	        return this.getStatesByClassNamePropName(className, propName).find(function (state) {
	            return state.id == stateId;
	        });
	    };
	
	    return StateStore;
	}(_liferayWidgetsReactWeb.ClassRemoteDataStore);
	
	exports.default = StateStore;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FormIds = exports.OVERALL_STATE_PROP_NAME = exports.ClassNames = exports.ActionTypes = undefined;
	
	var _keymirror = __webpack_require__(7);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTypes = exports.ActionTypes = {}; /**
	                                             * Created by Carsten Bühler
	                                             * User: CBuehler on 23.09.2015
	                                             * Copyright: xdot GmbH 2015
	                                             */
	var ClassNames = exports.ClassNames = (0, _keymirror2.default)({
	    StateValue: null,
	    State: null
	});
	
	var OVERALL_STATE_PROP_NAME = exports.OVERALL_STATE_PROP_NAME = 'overallState';
	
	var FormIds = exports.FormIds = (0, _keymirror2.default)({
	    STATE_DEFAULT_EDITFORM: null,
	    STATE_VALUE_DEFAULT_EDITFORM: null
	});

/***/ }),
/* 7 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_7__;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _Constants = __webpack_require__(6);
	
	var _StateValueWebApi = __webpack_require__(9);
	
	var _StateValueWebApi2 = _interopRequireDefault(_StateValueWebApi);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * User: CBuehler on 22.10.2015
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var StateValueStore = function (_ClassRemoteDataStore) {
	    _inherits(StateValueStore, _ClassRemoteDataStore);
	
	    function StateValueStore(Dispatcher) {
	        _classCallCheck(this, StateValueStore);
	
	        return _possibleConstructorReturn(this, _ClassRemoteDataStore.call(this, Dispatcher, _Constants.ClassNames.StateValue, _StateValueWebApi2.default.loadStatesValuesFromService, undefined));
	    }
	
	    return StateValueStore;
	}(_liferayWidgetsReactWeb.ClassRemoteDataStore);
	
	exports.default = StateValueStore;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _lwrClient = __webpack_require__(10);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	//const stateValueService = (m, o) => Client.invoke('/state.statevalue/' + m, o);
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 09.11.2015
	 * Copyright: xdot GmbH 2015
	 */
	
	var stateValueServiceWithContext = function stateValueServiceWithContext(m, o, c) {
	    return _lwrClient.Client.invokeWithContext('/state.statevalue/' + m, o, c);
	};
	
	var api = {
	    loadStatesValuesFromService: function loadStatesValuesFromService(query) {
	        return stateValueServiceWithContext('list-attached-by-prop-name.6', {
	            className: query.byClassName,
	            classPK: query.byId,
	            propName: query.byPropName,
	            start: query.start,
	            end: query.end
	        }, {});
	    }
	};
	
	_liferayWidgetsReactWeb.ApiUtil.namedApi('StateValueWebApi', api);
	
	exports.default = api;

/***/ }),
/* 10 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_10__;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016 xdot GmbH
	 * Author: Marius Runde
	 * Date: 29.06.2016
	 *
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _userStateHistoryPortlet = __webpack_require__(13);
	
	var _basePortlet = __webpack_require__(14);
	
	var _reactBootstrap = __webpack_require__(15);
	
	var _StateValueLabel = __webpack_require__(16);
	
	var _StateValueLabel2 = _interopRequireDefault(_StateValueLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	var MiniWidgetStatusLine = function MiniWidgetStatusLine(_ref) {
	    var status = _ref.status,
	        iconClass = _ref.iconClass,
	        onClick = _ref.onClick,
	        fastEditFunc = _ref.fastEditFunc;
	
	
	    var _onClickEditIcon = function _onClickEditIcon(e) {
	        e.stopPropagation();
	        fastEditFunc();
	    };
	
	    return _react2.default.createElement(
	        _basePortlet.MiniWidgetLineWrapper,
	        { onClick: onClick, className: 'status-line w-100' },
	        _react2.default.createElement(
	            'div',
	            { className: 'edit-button-wrapper' },
	            iconClass && _react2.default.createElement(_basePortlet.Icon, { name: iconClass }),
	            _react2.default.createElement(_StateValueLabel2.default, { item: status }),
	            fastEditFunc && _react2.default.createElement(
	                _reactBootstrap.Button,
	                {
	                    variant: 'outline-primary',
	                    title: 'Bearbeiten',
	                    className: 'mini-widget-edit-button',
	                    onClick: _onClickEditIcon
	                },
	                _react2.default.createElement(_basePortlet.Icon, { name: 'pencil', className: 'mini-widget-edit-icon', title: 'Bearbeiten' })
	            )
	        ),
	        _react2.default.createElement(_userStateHistoryPortlet.UserHistoryEntry, {
	            userMeta: status.userMeta,
	            timestamp: status.timestamp
	        })
	    );
	};
	exports.default = MiniWidgetStatusLine;

/***/ }),
/* 12 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_12__;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_13__;

/***/ }),
/* 14 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_14__;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_15__;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 17.02.2016
	 * Copyright: xdot GmbH 2015
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(17);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _userStateHistoryPortlet = __webpack_require__(13);
	
	var _reactBootstrap = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StateValueLabel = function StateValueLabel(_ref) {
	    var item = _ref.item,
	        _ref$showText = _ref.showText,
	        showText = _ref$showText === undefined ? true : _ref$showText,
	        _ref$stateName = _ref.stateName,
	        stateName = _ref$stateName === undefined ? undefined : _ref$stateName;
	
	    var tooltip = void 0;
	    if (!item) {
	        return null;
	    }
	
	    var getTranslation = function getTranslation(activeState) {
	        var title = _liferayWidgetsReactWeb.translation.trans((activeState.className ? activeState.className + '.' : '') + activeState.propName);
	
	        if (activeState.className === 'ManualBooleanState') {
	            title = 'Ereigniszustand';
	        }
	        return title;
	    };
	
	    if (item.userMeta && item.timestamp) {
	        tooltip = _react2.default.createElement(
	            _reactBootstrap.Tooltip,
	            { placement: 'bottom', className: 'in', id: 'tooltip-bottom' },
	            stateName ? stateName : getTranslation(item) + ': ' + item.state.stateTitle,
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_userStateHistoryPortlet.UserHistoryEntry, { userMeta: item.userMeta, timestamp: item.timestamp }),
	            item.comment && _react2.default.createElement(
	                'div',
	                null,
	                ' Kommentar: ',
	                item.comment,
	                ' '
	            )
	        );
	    }
	
	    var content = _react2.default.createElement(
	        _reactBootstrap.Badge,
	        { className: item.state && item.state.style && ' ' + item.state.style + ' ' },
	        _react2.default.createElement(
	            'span',
	            null,
	            showText && item.state && item.state.stateTitle || ''
	        )
	    );
	
	    if (tooltip) {
	        content = _react2.default.createElement(
	            _reactBootstrap.OverlayTrigger,
	            { trigger: ['click', 'hover'], placement: 'bottom', overlay: tooltip },
	            content
	        );
	    }
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        content
	    );
	};
	
	StateValueLabel.propTypes = {
	    item: _propTypes2.default.object.isRequired,
	    showText: _propTypes2.default.bool,
	    stateName: _propTypes2.default.string
	};
	
	exports.default = StateValueLabel;

/***/ }),
/* 17 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_17__;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: c.buehler on 22.03.2019
	 * Copyright: xdot GmbH 2019
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(17);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _basePortlet = __webpack_require__(14);
	
	var _reactBootstrap = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var validate = function validate(formData) {
	    var titleValid = void 0;
	
	    titleValid = _basePortlet.FormValidationUtil.validateStringMinLengthMaxLength(formData.title, 1, 75, 'Titel');
	
	    return {
	        title: titleValid
	    };
	};
	
	var StateEditForm = function (_React$Component) {
	    _inherits(StateEditForm, _React$Component);
	
	    function StateEditForm(props) {
	        _classCallCheck(this, StateEditForm);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.props.onChange(_this.props.formData, validate(_this.props.formData));
	        return _this;
	    }
	
	    StateEditForm.prototype.handleChange = function handleChange(field, e) {
	        this.change(field, e.target.value);
	    };
	
	    StateEditForm.prototype.change = function change(field, value) {
	        var _extends2;
	
	        var newData = _extends({}, this.props.formData, (_extends2 = {}, _extends2[field] = value, _extends2));
	
	        this.props.onChange(newData, validate(newData));
	    };
	
	    StateEditForm.prototype.render = function render() {
	        var _props = this.props,
	            formData = _props.formData,
	            formValidation = _props.formValidation;
	
	
	        return _react2.default.createElement(
	            _basePortlet.FliwasFormGrid,
	            null,
	            _react2.default.createElement(_basePortlet.FliwasFormHeading, { title: 'Status bearbeiten' }),
	            _react2.default.createElement(
	                _basePortlet.FliwasFormGroup,
	                { title: 'Titel',
	                    formValidation: formValidation,
	                    propName: 'title',
	                    required: true },
	                _react2.default.createElement(_reactBootstrap.FormControl, { type: 'text',
	                    required: true,
	                    placeholder: 'Titel',
	                    value: formData && formData.title ? formData.title : '',
	                    onChange: this.handleChange.bind(this, 'title') })
	            )
	        );
	    };
	
	    return StateEditForm;
	}(_react2.default.Component);
	
	StateEditForm.propTypes = {
	    onChange: _propTypes2.default.func,
	    formValidation: _propTypes2.default.object,
	    formData: _propTypes2.default.object
	};
	
	exports.default = StateEditForm;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 29.01.2016
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _basePortlet = __webpack_require__(14);
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(17);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StoreFactory = __webpack_require__(2);
	
	var _reactBootstrap = __webpack_require__(15);
	
	var _StateValueLabel = __webpack_require__(16);
	
	var _StateValueLabel2 = _interopRequireDefault(_StateValueLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StateStore = (0, _StoreFactory.getStateStore)(_liferayWidgetsReactWeb.AppContext);
	
	var StateSelect = function (_React$Component) {
	  _inherits(StateSelect, _React$Component);
	
	  function StateSelect(props) {
	    _classCallCheck(this, StateSelect);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    var state = _this.getCurrentState();
	    if (state) {
	      _this.props.onChange(parseInt(state.id));
	    }
	    return _this;
	  }
	
	  StateSelect.prototype.onStateChanged = function onStateChanged(id) {
	    this.props.onChange(id);
	  };
	
	  StateSelect.prototype.render = function render() {
	    var states = this.getStates();
	    var state = this.getCurrentState();
	    var _props$showLabel = this.props.showLabel,
	        showLabel = _props$showLabel === undefined ? true : _props$showLabel;
	
	    return _react2.default.createElement(
	      _reactBootstrap.Row,
	      null,
	      _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 12 },
	        _react2.default.createElement(_basePortlet.NumberSelect, {
	          list: states,
	          currentValue: state ? state.id : -1,
	          defaultOption: null,
	          onChange: this.onStateChanged.bind(this)
	        })
	      ),
	      showLabel && _react2.default.createElement(
	        _reactBootstrap.Col,
	        { xs: 12 },
	        _react2.default.createElement(_StateValueLabel2.default, { item: { state: state } })
	      )
	    );
	  };
	
	  StateSelect.prototype.getStates = function getStates() {
	    return StateStore.getStatesByClassNamePropName(this.props.className, this.props.propName).filter(function (s) {
	      return s.active;
	    }).map(function (s) {
	      return {
	        value: s.id,
	        label: s.stateTitle
	      };
	    });
	  };
	
	  StateSelect.prototype.getCurrentState = function getCurrentState() {
	    var _this2 = this;
	
	    var states = this.getStates();
	    var filtered = this.props.currentKey && states.filter(function (v) {
	      return v.value == _this2.props.currentKey;
	    }),
	        current = filtered && filtered.length > 0 ? filtered[0] : undefined;
	    return states && states.length > 0 ? StateStore.getStateByClassNamePropNameStateId(this.props.className, this.props.propName, this.state && this.state.currentValue || (current || states[0]).value) : undefined;
	  };
	
	  return StateSelect;
	}(_react2.default.Component);
	
	StateSelect.propTypes = {
	  onChange: _propTypes2.default.func.isRequired,
	  className: _propTypes2.default.string.isRequired,
	  propName: _propTypes2.default.string.isRequired,
	  currentKey: _propTypes2.default.number,
	  showLabel: _propTypes2.default.bool
	};
	
	exports.default = StateSelect;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 22.10.2015
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(17);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _StateSelect = __webpack_require__(19);
	
	var _StateSelect2 = _interopRequireDefault(_StateSelect);
	
	var _reactBootstrap = __webpack_require__(15);
	
	var _basePortlet = __webpack_require__(14);
	
	var _datefns = __webpack_require__(21);
	
	var _datefns2 = _interopRequireDefault(_datefns);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var validate = function validate(formData) {
	    var commentValid = void 0,
	        stateIdValid = void 0;
	    commentValid = _basePortlet.FormValidationUtil.validateStringMinLengthMaxLength(formData.comment, 1, 3999, 'Beschreibung');
	
	    if (!(formData.stateId > 0)) {
	        stateIdValid = 'Bitte Zustand auswählen!';
	    }
	
	    return {
	        comment: commentValid,
	        stateId: stateIdValid
	    };
	};
	
	var StateValueEditForm = function (_React$Component) {
	    _inherits(StateValueEditForm, _React$Component);
	
	    function StateValueEditForm(props) {
	        _classCallCheck(this, StateValueEditForm);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.props.onChange(_this.props.formData, validate(_this.props.formData));
	        return _this;
	    }
	
	    StateValueEditForm.prototype.handleStateChange = function handleStateChange(id) {
	        this.change('stateId', id);
	    };
	
	    StateValueEditForm.prototype.handleChange = function handleChange(field, e) {
	        this.change(field, e.target.value);
	    };
	
	    StateValueEditForm.prototype.onTimeChanged = function onTimeChanged(time) {
	        var t = _datefns2.default.startOfMinute(new Date(time.date)).getTime();
	        this.change('userTimestamp', t);
	    };
	
	    StateValueEditForm.prototype.change = function change(field, value) {
	        var _extends2;
	
	        var formData = this.props.formData,
	            item = formData.item || formData;
	
	        var newData = _extends({}, item, (_extends2 = {}, _extends2[field] = value, _extends2));
	
	        this.props.onChange(newData, validate(newData));
	    };
	
	    StateValueEditForm.prototype.render = function render() {
	        var _props = this.props,
	            formData = _props.formData,
	            formValidation = _props.formValidation;
	
	
	        return _react2.default.createElement(
	            _basePortlet.FliwasFormGrid,
	            null,
	            _react2.default.createElement(_basePortlet.FliwasFormHeading, { title: 'Zustand setzen' }),
	            _react2.default.createElement(
	                _basePortlet.FliwasFormGroup,
	                { title: 'Zustand',
	                    formValidation: formValidation,
	                    propName: formData.propName,
	                    required: true },
	                _react2.default.createElement(_StateSelect2.default, { name: 'stateId',
	                    required: true,
	                    className: formData.className,
	                    propName: formData.propName,
	                    onChange: this.handleStateChange.bind(this),
	                    currentKey: formData && formData.stateId })
	            ),
	            _react2.default.createElement(
	                _basePortlet.FliwasFormGroup,
	                { title: _liferayWidgetsReactWeb.translation.trans('description'),
	                    formValidation: formValidation,
	                    propName: 'comment',
	                    required: true },
	                _react2.default.createElement(_reactBootstrap.FormControl, { as: 'textarea',
	                    placeholder: _liferayWidgetsReactWeb.translation.trans('description'),
	                    rows: 3,
	                    cols: 40,
	                    required: true,
	                    value: formData && formData.comment ? formData.comment : '',
	                    onChange: this.handleChange.bind(this, 'comment') })
	            )
	        );
	    };
	
	    return StateValueEditForm;
	}(_react2.default.Component);
	
	StateValueEditForm.propTypes = {
	    formValidation: _propTypes2.default.object,
	    formData: _propTypes2.default.object,
	    onChange: _propTypes2.default.func,
	    states: _propTypes2.default.array
	};
	
	exports.default = StateValueEditForm;

/***/ }),
/* 21 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_21__;

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 22.10.2015
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(17);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(15);
	
	var _basePortlet = __webpack_require__(14);
	
	var _userStateHistoryPortlet = __webpack_require__(13);
	
	var _StateValueLabel = __webpack_require__(16);
	
	var _StateValueLabel2 = _interopRequireDefault(_StateValueLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StateValueListItem = function StateValueListItem(_ref) {
	    var item = _ref.item,
	        children = _ref.children;
	
	    return _react2.default.createElement(
	        _reactBootstrap.ListGroup.Item,
	        null,
	        children,
	        _react2.default.createElement(_StateValueLabel2.default, { item: item }),
	        ' ',
	        item.comment || '',
	        _react2.default.createElement('br', null),
	        item && item.userTimestamp && _react2.default.createElement(
	            'span',
	            null,
	            'Eingabezeitpunkt: ',
	            _react2.default.createElement(_basePortlet.DateTimeDisplay, { timestamp: item.userTimestamp }),
	            _react2.default.createElement('br', null)
	        ),
	        _react2.default.createElement(
	            'small',
	            { className: 'text-muted' },
	            _react2.default.createElement(_userStateHistoryPortlet.UserHistoryEntry, { userMeta: item.userMeta,
	                timestamp: item.timestamp })
	        )
	    );
	};
	
	StateValueListItem.propTypes = {
	    item: _propTypes2.default.object.isRequired,
	    children: _propTypes2.default.node
	};
	
	exports.default = StateValueListItem;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Hibbeler
	 * Copyright: xdot GmbH 2016
	 */
	
	'use strict';
	
	exports.__esModule = true;
	exports.StatusLine = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _basePortlet = __webpack_require__(14);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _userStateHistoryPortlet = __webpack_require__(13);
	
	var _StateValueActions = __webpack_require__(24);
	
	var _StateValueActions2 = _interopRequireDefault(_StateValueActions);
	
	var _StateValueLabel = __webpack_require__(16);
	
	var _StateValueLabel2 = _interopRequireDefault(_StateValueLabel);
	
	var _propTypes = __webpack_require__(17);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StateDetailsList = __webpack_require__(25);
	
	var _StateDetailsList2 = _interopRequireDefault(_StateDetailsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StatusLine = exports.StatusLine = function (_React$Component) {
	    _inherits(StatusLine, _React$Component);
	
	    function StatusLine(props) {
	        _classCallCheck(this, StatusLine);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = _extends({}, _this.state);
	
	        _this.onClickDetailsBox = _this.onClickDetailsBox.bind(_this);
	        return _this;
	    }
	
	    StatusLine.prototype.onClickDetailsBox = function onClickDetailsBox() {
	        (this.props.onClick || _StateValueActions2.default.openStatusHistory)(this.props.status);
	    };
	
	    StatusLine.prototype.render = function render() {
	        var _props = this.props,
	            status = _props.status,
	            title = _props.title;
	
	        return _react2.default.createElement(
	            'div',
	            {
	                role: 'button',
	                className: 'details-box-content nomargin nopadding single clickable hyphens-auto',
	                onClick: this.onClickDetailsBox
	            },
	            _react2.default.createElement(_StateValueLabel2.default, { item: status, stateName: title && title }),
	            _react2.default.createElement('br', null),
	            _react2.default.createElement(_userStateHistoryPortlet.UserHistoryEntry, { userMeta: status.userMeta, timestamp: status.timestamp })
	        );
	    };
	
	    return StatusLine;
	}(_react2.default.Component);
	
	function DetailsBoxStatus(props) {
	    var status = props.status;
	
	    var _useState = (0, _react.useState)(false),
	        stateDescriptionDialogOpened = _useState[0],
	        setStateDescriptionDialogOpened = _useState[1];
	
	    var onClickTitleIcon = function onClickTitleIcon() {
	        setStateDescriptionDialogOpened(true);
	    };
	
	    var onCloseStateDescriptionDialog = function onCloseStateDescriptionDialog() {
	        setStateDescriptionDialogOpened(false);
	    };
	
	    var title = _liferayWidgetsReactWeb.translation.trans(status.className + '.' + status.propName);
	
	    if (status.className === 'ManualBooleanState') {
	        title = 'Ereigniszustand';
	    }
	    return _react2.default.createElement(
	        _react2.default.Fragment,
	        null,
	        _react2.default.createElement(
	            _basePortlet.DetailsBox,
	            _extends({}, props, {
	                title: title,
	                titleIcon: 'info-o',
	                className: status.className,
	                onTitleIconClick: onClickTitleIcon
	            }),
	            _react2.default.createElement(StatusLine, _extends({}, props, { title: title }))
	        ),
	        _react2.default.createElement(
	            _liferayWidgetsReactWeb.CustomModal,
	            {
	                show: stateDescriptionDialogOpened,
	                onHide: onCloseStateDescriptionDialog,
	                size: 'xl'
	            },
	            _react2.default.createElement(_liferayWidgetsReactWeb.Title, { title: 'Status-Beschreibung: ' + title }),
	            _react2.default.createElement(
	                _liferayWidgetsReactWeb.CustomModalBody,
	                null,
	                _react2.default.createElement(_StateDetailsList2.default, { status: status })
	            )
	        )
	    );
	}
	
	DetailsBoxStatus.propTypes = {
	    status: _propTypes2.default.object,
	    title: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]),
	    onClick: _propTypes2.default.func,
	    fastEditFunc: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.bool])
	};
	StatusLine.propTypes = DetailsBoxStatus.propTypes;
	
	exports.default = DetailsBoxStatus;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _basePortlet = __webpack_require__(14);
	
	var _StateValueWebApi = __webpack_require__(9);
	
	var _StateValueWebApi2 = _interopRequireDefault(_StateValueWebApi);
	
	var _Constants = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 23.09.2015
	 * Copyright: xdot GmbH 2015
	 */
	
	var className = _Constants.ClassNames.StateValue;
	
	var api = 'StateValueWebApi';
	var listApiMethod = 'loadStatesValuesFromService';
	var itemApiMethod = '';
	
	exports.default = {
	
	    list: function list(name, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.list(name, className, query, api + '.' + listApiMethod);
	    },
	
	    attachedList: function attachedList(name, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.list(name, className, query, api + '.' + listApiMethod);
	    },
	    attachedItem: function attachedItem(name, byId, byClassName, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.attachedItem(name, className, api + '.' + itemApiMethod, byId, byClassName, query);
	    },
	
	    moreItems: function moreItems(name, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.moreItems(name, className, query);
	    },
	
	    createItem: function createItem(item, actionData) {
	        return _liferayWidgetsReactWeb.FormActions.submitForm(_StateValueWebApi2.default.addStateValue, item, actionData).key;
	    },
	
	    openStatusHistory: function openStatusHistory(state) {
	        _basePortlet.ModalActions.showModal(_Constants.ClassNames.StateValue, {
	            byClassName: state.className,
	            byId: state.classPK,
	            byPropName: state.propName,
	            start: 0,
	            end: _liferayWidgetsReactWeb.AppContext.DEFAULT_LIST_SIZE
	        }, true, { state: state, size: "xl" });
	    }
	
	};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(17);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(15);
	
	var _basePortlet = __webpack_require__(14);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _StoreFactory = __webpack_require__(2);
	
	var _StateValueLabel = __webpack_require__(16);
	
	var _StateValueLabel2 = _interopRequireDefault(_StateValueLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * User: c.buehler on 01.02.2019
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright: xdot GmbH 2019
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var StateStore = (0, _StoreFactory.getStateStore)(_liferayWidgetsReactWeb.AppContext);
	
	var StateDetailsList = function (_React$Component) {
	    _inherits(StateDetailsList, _React$Component);
	
	    function StateDetailsList() {
	        _classCallCheck(this, StateDetailsList);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    StateDetailsList.prototype.render = function render() {
	        var status = this.props.status;
	
	        var states = StateStore.getStatesByClassNamePropName(status.className, status.propName);
	
	        return _react2.default.createElement(
	            _reactBootstrap.Table,
	            { striped: true, bordered: true },
	            _react2.default.createElement(
	                'thead',
	                null,
	                _react2.default.createElement(
	                    'tr',
	                    null,
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Titel'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Visualisierung'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Gesamtzustand'
	                    ),
	                    _react2.default.createElement(
	                        'th',
	                        null,
	                        'Beschreibung'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'tbody',
	                null,
	                states.filter(function (s) {
	                    return s.active;
	                }).sort(function (s1, s2) {
	                    return s1.weight === s2.weight ? 0 : s1.weight > s2.weight ? 1 : -1;
	                }).map(function (s) {
	                    return _react2.default.createElement(
	                        'tr',
	                        { key: 'state_' + s.id },
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            s.stateTitle
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement(_StateValueLabel2.default, { item: { state: s } })
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement('span', {
	                                className: 'overall-state-box state-' + (s.overallState || s.state.overallState) })
	                        ),
	                        _react2.default.createElement(
	                            'td',
	                            null,
	                            _react2.default.createElement(_basePortlet.ItemDescription, { item: s })
	                        )
	                    );
	                })
	            )
	        );
	    };
	
	    return StateDetailsList;
	}(_react2.default.Component);
	
	StateDetailsList.propTypes = {
	    status: _propTypes2.default.object.isRequired
	};
	
	exports.default = StateDetailsList;

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(17);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _StateValueListItem = __webpack_require__(22);
	
	var _StateValueListItem2 = _interopRequireDefault(_StateValueListItem);
	
	var _StoreFactory = __webpack_require__(2);
	
	var _StateValueActions = __webpack_require__(24);
	
	var _StateValueActions2 = _interopRequireDefault(_StateValueActions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StateValueListLink = _liferayWidgetsReactWeb.DataLinkContainer.link(_liferayWidgetsReactWeb.ScrollableDataList, 'list', (0, _StoreFactory.getStateValueStore)(_liferayWidgetsReactWeb.AppContext));
	
	var StateValueList = function StateValueList(_ref) {
	    var statusHistory = _ref.statusHistory;
	
	
	    var moreStatusHistory = function moreStatusHistory(query) {
	        _StateValueActions2.default.moreItems(statusHistory, query);
	    };
	
	    return _react2.default.createElement(StateValueListLink, { list: statusHistory,
	        ListItem: _StateValueListItem2.default,
	        listSize: 'list-small',
	        onClickMore: moreStatusHistory.bind(undefined) });
	};
	
	StateValueList.propTypes = {
	    statusHistory: _propTypes2.default.string.isRequired
	};
	
	exports.default = StateValueList;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: c.buehler on 23.04.2019
	 * Copyright: xdot GmbH 2019
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(17);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _basePortlet = __webpack_require__(14);
	
	var _StateValueLabel = __webpack_require__(16);
	
	var _StateValueLabel2 = _interopRequireDefault(_StateValueLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FliwasStatusIcon = function FliwasStatusIcon(props) {
	    return _react2.default.createElement(
	        'div',
	        { className: 'object-icon' },
	        _react2.default.createElement(_basePortlet.Icon, { name: props.iconClassName }),
	        props.stateValue && _react2.default.createElement(_StateValueLabel2.default, { item: props.stateValue, showText: false })
	    );
	};
	FliwasStatusIcon.propTypes = {
	    iconClassName: _propTypes2.default.string.isRequired,
	    stateValue: _propTypes2.default.object.isRequired
	};
	
	exports.default = FliwasStatusIcon;

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Hibbeler
	 * Copyright: xdot GmbH 2016
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StateValueActions = __webpack_require__(24);
	
	var _StateValueActions2 = _interopRequireDefault(_StateValueActions);
	
	var _StateValueLabel = __webpack_require__(16);
	
	var _StateValueLabel2 = _interopRequireDefault(_StateValueLabel);
	
	var _propTypes = __webpack_require__(17);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _basePortlet = __webpack_require__(14);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FliwasListItemStatus = function (_React$Component) {
	    _inherits(FliwasListItemStatus, _React$Component);
	
	    function FliwasListItemStatus(props) {
	        _classCallCheck(this, FliwasListItemStatus);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.onClickDetailsBox = _this.onClickDetailsBox.bind(_this);
	        return _this;
	    }
	
	    FliwasListItemStatus.prototype.onClickDetailsBox = function onClickDetailsBox() {
	        _StateValueActions2.default.openStatusHistory(this.props.stateValue);
	    };
	
	    FliwasListItemStatus.prototype.getTranslation = function getTranslation(activeState) {
	        var title = _liferayWidgetsReactWeb.translation.trans((activeState.className ? activeState.className + '.' : '') + activeState.propName);
	
	        if (activeState.className === 'ManualBooleanState') {
	            title = 'Ereigniszustand';
	        }
	        return title;
	    };
	
	    FliwasListItemStatus.prototype.render = function render() {
	        var stateValue = this.props.stateValue;
	
	
	        if (!stateValue) {
	            return null;
	        }
	
	        var title = this.getTranslation(stateValue);
	        return _react2.default.createElement(
	            'div',
	            { className: 'list-item-state-wrapper' },
	            _react2.default.createElement(
	                'span',
	                { className: 'list-item-status', onClick: this.onClickDetailsBox },
	                _react2.default.createElement(_StateValueLabel2.default, { stateName: title && title, item: stateValue })
	            ),
	            _react2.default.createElement(_basePortlet.DateTimeDisplay, { timestamp: stateValue.timestamp, classNames: 'date' })
	        );
	    };
	
	    return FliwasListItemStatus;
	}(_react2.default.Component);
	
	FliwasListItemStatus.propTypes = {
	    stateValue: _propTypes2.default.object.isRequired
	};
	
	exports.default = FliwasListItemStatus;

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 01.04.2016
	 * Copyright: xdot GmbH 2015
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(17);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _basePortlet = __webpack_require__(14);
	
	var _StoreFactory = __webpack_require__(2);
	
	var _StateValueLabel = __webpack_require__(16);
	
	var _StateValueLabel2 = _interopRequireDefault(_StateValueLabel);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var StateStore = (0, _StoreFactory.getStateStore)(_liferayWidgetsReactWeb.AppContext);
	
	var StateValueChangeRecordRenderer = function (_React$Component) {
	    _inherits(StateValueChangeRecordRenderer, _React$Component);
	
	    function StateValueChangeRecordRenderer(props) {
	        _classCallCheck(this, StateValueChangeRecordRenderer);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.removeListener = StateStore.addListener(_this.onStateStoreChanged.bind(_this));
	
	        return _this;
	    }
	
	    StateValueChangeRecordRenderer.prototype.onStateStoreChanged = function onStateStoreChanged() {
	        if (!StateStore.getGroupRemoteState()._loading && !StateStore.getGroupRemoteState()._error) {
	            if (this.removeListener) {
	                this.removeListener.remove();
	            }
	        }
	
	        this.setState({});
	    };
	
	    StateValueChangeRecordRenderer.prototype.getTranslation = function getTranslation(activeState) {
	        var title = _liferayWidgetsReactWeb.translation.trans((activeState.className ? activeState.className + '.' : '') + activeState.propName);
	
	        if (activeState.className === 'ManualBooleanState') {
	            title = 'Ereigniszustand';
	        }
	        return title;
	    };
	
	    StateValueChangeRecordRenderer.prototype.render = function render() {
	        var _props = this.props,
	            changeRecord = _props.changeRecord,
	            userMeta = _props.userMeta;
	
	
	        var activeState = StateStore.getStateByClassNamePropNameStateId(changeRecord.attachedClassName, changeRecord.changes.propName.newValue, parseInt(changeRecord.changes.stateId.newValue));
	
	        if (!(activeState && activeState.stateTitle && activeState.propName)) {
	            console.warn('No ActiveState for StateValueRenderer', changeRecord, activeState);
	            return _react2.default.createElement(
	                _basePortlet.TimeLineItem,
	                { userMeta: userMeta, timestamp: changeRecord.timestamp },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'd-flex align-items-center h-100' },
	                    'Status wurde nicht gefunden!'
	                )
	            );
	        }
	
	        var title = this.getTranslation(activeState);
	
	        return _react2.default.createElement(
	            _basePortlet.TimeLineItem,
	            { userMeta: userMeta, timestamp: changeRecord.timestamp },
	            _react2.default.createElement(
	                _basePortlet.TimeLineItemMessageHeader,
	                null,
	                _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Zustands\xE4nderung f\xFCr',
	                    ' ',
	                    _liferayWidgetsReactWeb.translation.trans(changeRecord.attachedClassName) + ' ',
	                    _react2.default.createElement(_basePortlet.BusinessObjectLink, {
	                        className: changeRecord.attachedClassName,
	                        classPK: changeRecord.attachedClassPK
	                    }),
	                    ' '
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'my-3' },
	                'Neuer ',
	                title,
	                ' gesetzt.',
	                _react2.default.createElement('br', null),
	                _react2.default.createElement(_StateValueLabel2.default, { stateName: title && title, item: {
	                        state: activeState,
	                        userMeta: userMeta,
	                        timestamp: changeRecord.timestamp,
	                        className: activeState.className,
	                        propName: activeState.propName
	                    } }),
	                _react2.default.createElement('br', null),
	                changeRecord && changeRecord.changes.userTimestamp && changeRecord.changes.userTimestamp.newValue && _react2.default.createElement(
	                    'div',
	                    null,
	                    'Eingabezeitpunkt: ',
	                    _react2.default.createElement(_basePortlet.DateTimeDisplay, {
	                        timestamp: changeRecord.changes.userTimestamp.newValue })
	                ),
	                'Kommentar:',
	                ' ' + changeRecord.changes.comment.newValue
	            )
	        );
	    };
	
	    return StateValueChangeRecordRenderer;
	}(_react2.default.Component);
	
	StateValueChangeRecordRenderer.propTypes = {
	    item: _propTypes2.default.object,
	    changeRecord: _propTypes2.default.object,
	    userMeta: _propTypes2.default.object
	};
	
	exports.default = StateValueChangeRecordRenderer;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 22.10.2015
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(12);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(17);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _StateValueActions = __webpack_require__(24);
	
	var _StateValueActions2 = _interopRequireDefault(_StateValueActions);
	
	var _StateValueListItem = __webpack_require__(22);
	
	var _StateValueListItem2 = _interopRequireDefault(_StateValueListItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StateValueDetailsListRenderer = function StateValueDetailsListRenderer(_ref) {
	  var item = _ref.item,
	      state = _ref.state;
	
	  var list = item;
	  var listItems = _liferayWidgetsReactWeb.DataUtil.asArray(item);
	
	  var getTranslation = function getTranslation(state) {
	    var title = _liferayWidgetsReactWeb.translation.trans(state.className + '.' + state.propName);
	
	    if (state.className === 'ManualBooleanState') {
	      title = 'Ereigniszustand';
	    }
	    return title;
	  };
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(_liferayWidgetsReactWeb.Title, { title: state ? getTranslation(state) : 'Status' }),
	    _react2.default.createElement(_liferayWidgetsReactWeb.ScrollableDataListRV, {
	      list: list,
	      ListItem: _StateValueListItem2.default,
	      size: 'medium',
	      loadMoreRows: function loadMoreRows(query) {
	        return _StateValueActions2.default.moreItems(list.name, query);
	      },
	      rowHeight: function rowHeight(_ref2) {
	        var index = _ref2.index;
	
	        var currentItem = listItems && listItems[index];
	        // state set by an app user
	        var hasUserTimestamp = currentItem && currentItem.userTimestamp;
	        return hasUserTimestamp ? 70 : 50;
	      }
	    })
	  );
	};
	
	StateValueDetailsListRenderer.propTypes = {
	  item: _propTypes2.default.object.isRequired,
	  state: _propTypes2.default.object
	};
	
	exports.default = StateValueDetailsListRenderer;

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _lwrClient = __webpack_require__(10);
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 17.11.2015
	 * Copyright: xdot GmbH 2015
	 */
	
	var stateService = function stateService(m, o) {
	    return _lwrClient.Client.invoke('/state.state/' + m, o);
	};
	var stateServiceWithContext = function stateServiceWithContext(m, o, c) {
	    return _lwrClient.Client.invokeWithContext('/state.state/' + m, o, c);
	};
	
	var api = {
	    loadStatesFromService: function loadStatesFromService() {
	        return stateServiceWithContext('list-all.1');
	    },
	    loadStateFromService: function loadStateFromService(id) {
	        return stateService('get.1', {
	            id: id
	        });
	    },
	    addState: function addState(data) {
	        return stateServiceWithContext('add.1', {}, {
	            className: parseInt(data.className),
	            stateTitle: data.stateTitle,
	            stateKey: data.stateKey,
	            description: data.description,
	            style: data.style
	        });
	    },
	    editState: function editState(data) {
	        return stateServiceWithContext('update.2', {
	            id: data.id
	        }, {
	            className: parseInt(data.className),
	            stateTitle: data.stateTitle,
	            stateKey: data.stateKey,
	            description: data.description,
	            style: data.style
	        });
	    }
	};
	
	_liferayWidgetsReactWeb.ApiUtil.namedApi('StateWebApi', api);
	
	exports.default = api;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _liferayWidgetsReactWeb = __webpack_require__(4);
	
	var _StateWebApi = __webpack_require__(31);
	
	var _StateWebApi2 = _interopRequireDefault(_StateWebApi);
	
	var _Constants = __webpack_require__(6);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	
	    load: function load() {
	        return _liferayWidgetsReactWeb.RemoteDataActions.list('all', _Constants.ClassNames.State, {}, _StateWebApi2.default.loadStatesFromService);
	    },
	
	    list: function list(name, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.list(name, _Constants.ClassNames.State, query, _StateWebApi2.default.loadStatesFromService);
	    },
	    item: function item(name, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.item(name, _Constants.ClassNames.State, query, _StateWebApi2.default.loadStateFromService);
	    },
	
	    attachedList: function attachedList(name, byId, byClassName, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.attachedList(name, _Constants.ClassNames.State, _StateWebApi2.default.loadStatesFromService, byId, byClassName, query);
	    },
	
	    attachedItem: function attachedItem(name, byId, byClassName, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.attachedItem(name, _Constants.ClassNames.State, _StateWebApi2.default.loadStateFromService, byId, byClassName, query);
	    },
	
	    moreItems: function moreItems(name, query) {
	        return _liferayWidgetsReactWeb.RemoteDataActions.moreItems(name, _Constants.ClassNames.State, query);
	    },
	
	    createItem: function createItem(item, actionData) {
	        return _liferayWidgetsReactWeb.FormActions.submitForm(_StateWebApi2.default.addState, item, actionData).key;
	    },
	    updateItem: function updateItem(item, actionData) {
	        return _liferayWidgetsReactWeb.FormActions.submitForm(_StateWebApi2.default.editState, item, actionData).key;
	    },
	    deleteItem: function deleteItem(item, actionData) {
	        return _liferayWidgetsReactWeb.FormActions.submitForm(_StateWebApi2.default.deleteState, item, actionData).key;
	    }
	
	}; /**
	    * Created by Carsten Bühler
	    * User: CBuehler on 29.10.2015
	    * Copyright: xdot GmbH 2015
	    */

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// state-portlet.js